<div class="modal-header">
  <h2 class="modal-title">Project</h2>
</div>
<div class="flex-fill d-flex flex-column">
  <div class="card">
    <div class="card-body">
      @if (!processing) {
        <dx-form [formData]="entity" [colCount]="1" validationGroup="mainValidationGroup">
          <dxi-item itemType="group">
            <dxi-item dataField="created" editorType="dxDateBox" [editorOptions]="{ type: 'date', width: '150px', disabled: true }" [label]="{ text: 'Date' }"> </dxi-item>
            <dxi-item dataField="projectNumber" editorType="dxNumberBox" [editorOptions]="{ step: 0 }">
              <dxi-validation-rule  type="required" message="Required"> </dxi-validation-rule>
              <dxi-validation-rule type="numeric" message="Needs to be a number"> </dxi-validation-rule>
              <dxi-validation-rule type="range" [min]="0" message="Cannot be less than 0"> </dxi-validation-rule>
            </dxi-item>
            <dxi-item dataField="name">
              <dxi-validation-rule type="required" message="Required"> </dxi-validation-rule>
            </dxi-item>
            <dxi-item dataField="description" [label]="{ text: 'Description' }" editorType="dxTextArea" editorOptions="{height: 50px}"> </dxi-item>
          </dxi-item>
        </dx-form>
      }
    </div>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-danger" (click)="save()">{{ "Save" }}</button>
  <button type="button" class="btn btn-success" (click)="close()">{{ "Close" }}</button>
</div>
